export default __webpack_public_path__ + "static/media/Rect1.fa639f78.svg";